import { Document, Node, helpers } from '@contentful/rich-text-types';
import { RichText } from '../graphql.generated';

const isValidNode = (node?: Node | null) => {
    if (!node) return false;
    return (
        helpers.isText(node) || helpers.isBlock(node) || helpers.isInline(node)
    );
};
/**
 * A predicate for checking whether the value received from Contentful is safe
 * to say is a Document.
 * If you find that your content isn't displaying, ensure that you have all
 * three of "content", "data", and "nodeType" in your query, without these it
 * will not be treated as a valid Document and this will return false.
 */
export const isDocument = (
    richText?: RichText | Document | null
): richText is Document => {
    return Boolean(
        richText &&
            Array.isArray(richText.content) &&
            richText.content.every(isValidNode) &&
            richText.nodeType === 'document' &&
            richText.data
    );
};
